import get from 'Utils/lodash.get';
import { isObject } from 'Helpers/utils/common';

export default function (file) {
  if (!isObject(file)) {
    return '';
  }
  if (file.id) {
    return get(file, 'meta_data.name') || file.name || '';
  }
  return get(file, 'original.meta_data.name') || get(file, 'original.name') || '';
}
